import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../../../Context/AuthContext';
import DummyProfile from '../../../assets/DummyProfile';
import { useNavigate } from 'react-router-dom';
import useUserStore from '../../../store/userStore';
import { translate } from '../../../i18n';
import { PATH_MY_AVAILABILITY } from '../../../routes/routesConfig';
const ProfileDropdown: React.FC = () => {
  const user = useUserStore((state) => state.user);
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleLogout = () => {
    logout();
    navigate('/operations');
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={toggleDropdown}
        className={`flex items-center justify-center w-10 h-10 rounded-full bg-backgroundColor-darkThemeColor focus:outline-none`}
      >
        <DummyProfile fill={'var(--profileIconColor)'} />
      </button>
      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-backgroundColor-white border rounded-lg shadow-lg z-10">
          <div className="p-4 text-start border-b">
            <p className="text-textColorGray font-medium">
              {user?.staffName ? user?.staffName : ''}
            </p>
          </div>
          <button
            onClick={() => {
              setIsOpen(false);
              navigate(PATH_MY_AVAILABILITY);
            }}
            className="w-full text-left px-4 py-2 text-textColor hover:bg-gray-100"
          >
            {translate('common.myAvailability')}
          </button>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSfnJ-UY4gdVP1iRC3QEjeIzcif75CP46N6pHoh8Jyru8zqW1w/viewform"
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full text-left px-4 py-2 text-textColor hover:bg-gray-100"
          >
            {translate('common.feedBack')}
          </a>
          <button
            onClick={() => handleLogout()}
            className="w-full text-left px-4 py-2 text-textColor hover:bg-gray-100"
          >
            {translate('common.logout')}
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfileDropdown;
